// 同步改变state
// 按类划分
// 命名：show/hide、get/set、add/reduce...
import { saveUserInfo } from '@/utils/api';

export default {
	/**
	 * 存储用户信息（用于新用户登录同意协议）
	 * **/
	setLoginPara(state, value) {
		state.loginPara = value;
	},

	/**
	 * agreementBox
	 *  **/
	showAgreementBox(state) {
		state.agreement_box = true;
	},

	hideAgreementBox(state) {
		state.agreement_box = false;
	},

	// 设置电子签预览信息
	setVisaViewInfo(state, value) {
		console.log(state, value, 111);
		state.visaViewInfo = { ...state.visaViewInfo, ...value };
	}
	//   setRecordVerify(value){}
};
